import { useTheme as useThemeContext } from "./themeContext";

export const useTheme = () => {
  const { theme } = useThemeContext();
  return theme;
};
